/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Current_StepInputs */

const en_current_step = /** @type {(inputs: Current_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Step`)
};

const fr_current_step = /** @type {(inputs: Current_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Étape actuelle`)
};

const de_current_step = /** @type {(inputs: Current_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktueller Schritt`)
};

const it_current_step = /** @type {(inputs: Current_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passo attuale`)
};

const ru_current_step = /** @type {(inputs: Current_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущий шаг`)
};

const es_current_step = /** @type {(inputs: Current_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paso actual`)
};

const zh_cn2_current_step = /** @type {(inputs: Current_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前步骤`)
};

const ja_current_step = /** @type {(inputs: Current_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在のステップ`)
};

const hi_current_step = /** @type {(inputs: Current_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान चरण`)
};

const pt_pt2_current_step = /** @type {(inputs: Current_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etapa atual`)
};

/**
* | output |
* | --- |
* | "Current Step" |
*
* @param {Current_StepInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const current_step = /** @type {((inputs?: Current_StepInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Current_StepInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_current_step(inputs)
	if (locale === "de") return de_current_step(inputs)
	if (locale === "it") return it_current_step(inputs)
	if (locale === "ru") return ru_current_step(inputs)
	if (locale === "es") return es_current_step(inputs)
	if (locale === "zh-CN") return zh_cn2_current_step(inputs)
	if (locale === "ja") return ja_current_step(inputs)
	if (locale === "hi") return hi_current_step(inputs)
	if (locale === "pt-PT") return pt_pt2_current_step(inputs)
	return en_current_step(inputs)
});